export const WIDGET_WINDOW_CHANNEL_NAME = "addboard.widget-windows";

export type WidgetWindowMessage =
  | { type: "hello" | "bye" | "close" | "focus"; widgetId: string }
  | { type: "who-is-there" };

export interface WidgetWindowChannel {
  postMessage(message: WidgetWindowMessage): void;
  addEventListener(
    type: "message",
    listener: (event: MessageEvent<WidgetWindowMessage>) => void,
  ): void;
  close(): void;
}

export function widgetWindowName(widgetId: string): string {
  return `addboard-widget-${widgetId}`;
}
